const queries = {
  injuryReports: () => ['injury-reports'],
  injuryReport: (id: number) => ['injury-reports', id],
}

export default queries
